var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8963 7.04163L7.242 4.99056H5.08048V3.65956C5.08048 3.09842 5.38243 2.55146 6.35051 2.55146H7.33317V0.805194C7.33317 0.805194 6.44143 0.666626 5.58883 0.666626C3.80875 0.666626 2.64521 1.649 2.64521 3.42736V4.99056H0.666504V7.04163H2.64521V12H5.08048V7.04163H6.8963Z",
    fill: "#A5AEB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1431867a32563f240b3d0947f71af13c.svg";
export { ForwardRef as ReactComponent };